import { QuestionType } from "@hulanbv/ssllow-packages";
import { dictionary } from "./i18n/dictionary";

export const questionTypeLabels: { [key in QuestionType]: string } = {
  [QuestionType.CONSTRUCTIVE]: dictionary.constructive,
  [QuestionType.DESTRUCTIVE]: dictionary.destructive,
};
